module.exports = __webpack_public_path__ + "img/client_logo_5.ddc39eb0.png";